import { useMemo } from 'react';
import { Select, SelectProps } from '@robocorp/components';
import { useTranslation } from 'react-i18next';
import { LOCAL_TZ_VALUE, TZ_ITEMS } from '../utils/timezoneHelpers';

interface Props extends Omit<SelectProps, 'items'> {
  withLocalValue?: boolean;
}

export default function TimezoneSelect({ value, withLocalValue, ...rest }: Props) {
  const { t } = useTranslation();
  let selectedTz = value;
  if (withLocalValue) {
    selectedTz = value || LOCAL_TZ_VALUE;
  }

  const items = useMemo(() => {
    if (!withLocalValue) return TZ_ITEMS;
    return [{ value: LOCAL_TZ_VALUE, label: t('localTime') }, ...TZ_ITEMS];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [withLocalValue]);

  // eslint-disable-next-line react/jsx-props-no-spreading
  return (
    <Select
      items={items}
      value={selectedTz}
      searchable
      aria-label="timezone select"
      variant="display"
      {...rest}
    />
  );
}

TimezoneSelect.defaultProps = {
  withLocalValue: undefined,
};
